'use strict';

const _=require('pulsar-utils/dist-es6/_');
const TableColumn=require('../../../../dist-es6/client/directives/sortableTableDirective/tableColumn');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

SortableTableDirective=class SortableTableDirective extends BaseControllerBackedDirective{
get restrict(){
return'E';
}

get objectBindings(){
return['tableData','columnDefinitions','searchablePropertiesOnData','filteredTableData','onRowClick','currentFilter','context'];
}

get textBindings(){
return['headerRowClass','emptyArrayMessage','noSearchResultsMessage','itemTypeName','pluralItemTypeName','singleItemTypeName'];
}

get template(){
return($elem,$attr)=>{
let searchBoxMarkup=
`<pulsar-search class="table-filter"
                data="controller.tableData"
                searchable-properties="controller.searchablePropertiesOnData"
                current-filter="controller.currentFilter"
                filtered-data="controller.filteredTableData"
                debounce-rate="controller.searchDebounceRate" />`;
let tableStartMarkup=
`<table>
                    <thead>
                        <tr ng-class="controller.headerRowClass">
                            <td pulsar-column-header
                                data-ng-repeat="tableColumn in controller.tableColumns"
                                table-column="tableColumn"
                                sortable-table-controller="controller">
                            </td>
                        </tr>
                    </thead>
                ${$attr.showVerticalScrollbar==='true'?'</table><pulsar-scrollbar><div><table>':''}
                    <tbody>
                        <tr ng-if="controller.filteredTableData && controller.filteredTableData.length > 0"
                            data-ng-repeat="item in controller.filteredTableData | orderBy: controller.orderBy | filter: controller.filterToItemsStartingAtOrAfterIndex | limitTo: controller.itemsPerPage track by $index"
                            data-ng-class="{clickable: controller.onRowClick !== undefined}"
                            data-ng-click="controller.onRowClick(item, $event) || null">`;

let template=searchBoxMarkup+tableStartMarkup;

angular.forEach($elem.find('> div'),function(item){
let columnString=item.outerHTML.replace(/^<div/i,'<td').replace(/<\/div>$/i,'</td>');


template+=columnString;
});

let tableEndMarkup=
`</tr>
                        <tr data-ng-if="controller.filteredTableData.length === 0" class="empty">
                            <td colspan="{{controller.tableColumns.length}}">{{controller.currentFilter.length > 0 && controller.noSearchResultsMessage ? controller.noSearchResultsMessage : controller.emptyArrayMessage}}</td>
                        </tr>
                    </tbody>
                </table>
            ${$attr.showVerticalScrollbar==='true'?'</div><div class="clearfix"></div></pulsar-scrollbar>':''}
            <div class="pagination-container" ng-if="$root.Pulsar.lodash.exists(controller.pages) && controller.pages.length > 0">
                <ol class="page-navigation">
                    <li>
                        <span>{{controller.currentPageLabel}}</span>
                    </li>
                    <li ng-if="controller.pages.length > 1">
                        <button class="previous-page"
                            ng-disabled="controller.currentPageIndex === 0"
                            ng-click="controller.goToPage(controller.currentPageIndex - 1)"
                            alt="View Previous Page"
                            title="View Previous Page">
                            <img class="play-icon reverse" src="/images/Play.svg" />
                        </button>
                    </li>
                    <li class="first-page" ng-if="controller.pages.length > controller.numPagesToShow && controller.currentPageIndex >= controller.numPagesToShow - controller.numPagesToShowBeforeCurrent">
                        <button class="page-number"
                            ng-click="controller.goToPage(0)"
                            alt="View First Page"
                            title="View First Page">1</button>
                        <span>…</span>
                    </li>
                    <li ng-if="controller.pages.length > 1" data-ng-repeat="page in controller.pages | filter: controller.filterToPagesStartingNearPageIndex | limitTo: controller.numPagesToShow track by $index">
                        <button class="page-number"
                            ng-class="{selected: controller.currentPageIndex === page}"
                            ng-click="controller.goToPage(page)"
                            alt="View Page {{page + 1}}"
                            title="View Page {{page + 1}}">
                            {{page + 1}}
                        </button>
                    </li>
                    <li class="last-page" ng-if="controller.pages.length > controller.numPagesToShow && controller.currentPageIndex < controller.pages.length - controller.numPagesToShowBeforeCurrent - 1">
                        <span>…</span>
                        <button class="page-number"
                            ng-click="controller.goToPage(controller.pages[controller.pages.length - 1])"
                            alt="View Last Page"
                            title="View Last Page">{{controller.pages.length}}</button>
                    </li>
                    <li ng-if="controller.pages.length > 1">
                        <button class="next-page"
                            ng-disabled="controller.currentPageIndex === (controller.pages.length-1)"
                            ng-click="controller.goToPage(controller.currentPageIndex + 1)"
                            alt="View Next Page"
                            title="View Next Page">
                            <img class="play-icon" src="/images/Play.svg" />
                        </button>
                    </li>
                </ol>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>`;

template+=tableEndMarkup;

return template;
};
}

get controller(){
return SortableTableDirectiveController;
}

factory(){
let directive=super.factory();
return directive;
}};let


SortableTableDirectiveController=class SortableTableDirectiveController{
static get $inject(){
return['$scope','$timeout','$element'];
}

constructor($scope,$timeout,$element){
this._$timeout=$timeout;
this._$element=$element;

this._tableColumns=this.columnDefinitions.map(columnDefinition=>this._getSortableColumn(columnDefinition));
this._activeColumn=_.find(this._tableColumns,{isActive:!0});

if(!_.exists(this._activeColumn)){
throw new Error('At least one column must have {isInitiallyActive: true} set.');
}

this.itemTypeName=this.itemTypeName||'Row';

this._isInitialized=!1;
this.itemsPerPage=10;
this.numPagesToShow=5;
this.currentPageIndex=0;
this.searchDebounceRate=0;
this.pages=[];
this.currentFilter=this.currentFilter||'';

this.numPagesToShowBeforeCurrent=Math.floor(this.numPagesToShow/2);
this.filterToItemsStartingAtOrAfterIndex=this.filterToItemsStartingAtOrAfterIndex.bind(this);
this.filterToPagesStartingNearPageIndex=this.filterToPagesStartingNearPageIndex.bind(this);

$scope.$watch('controller.filteredTableData',filteredData=>this._updatePagination(filteredData));

this._updatePagination(this.data);
}

_updatePagination(data){
if(!_.exists(data)){
return;
}

this.pages=_.range(Math.ceil(data.length/this.itemsPerPage));
this.goToPage(0);
this._isInitialized=!0;
}

_getSortableColumn(columnDefinition){
let{
label,
defaultAscending,
orderBy,
finalSort,
isInitiallyActive,
columnClass}=
columnDefinition;

return new TableColumn(label,orderBy,defaultAscending,finalSort,isInitiallyActive,columnClass);
}

sortBy(tableColumn){
if(tableColumn.sortDisabled){
return;
}

this._$timeout(()=>{
for(let col of this._tableColumns){
if(col===tableColumn){
this._activeColumn=tableColumn;
this._activeColumn.sort();
}else{
col.endSort();
}
}
});
}

goToPage(pageIndex){
this.currentPageIndex=pageIndex;
}

filterToItemsStartingAtOrAfterIndex(item,index){
return index>=this.currentPageIndex*this.itemsPerPage;
}

filterToPagesStartingNearPageIndex(item,index){
return index>=this.pages.length-this.numPagesToShow||index>=this.currentPageIndex-this.numPagesToShowBeforeCurrent;
}

get availableData(){
return this.filteredTableData||this.tableData;
}

_getPluralizedItemTypeName(){
return this.availableData.length===1?
this.singleItemTypeName||this.itemTypeName:
this.pluralItemTypeName||this.itemTypeName+'s';
}

get currentPageLabel(){
const dataLength=this.availableData.length;
let pageStartItemIndex=this.currentPageIndex*this.itemsPerPage;
let numOnCurrentPage=this.currentPageIndex<this.pages.length-1?this.itemsPerPage:dataLength-pageStartItemIndex;
let pluralizedItemTypeName=this._getPluralizedItemTypeName();
return`${pageStartItemIndex+1}-${pageStartItemIndex+numOnCurrentPage} of ${dataLength} ${pluralizedItemTypeName}`;
}

get orderBy(){
return this._activeColumn.orderBy;
}

get tableColumns(){
return this._tableColumns;
}};


module.exports=SortableTableDirective;
module.exports.controller=SortableTableDirectiveController;
//# sourceMappingURL=sortableTableDirective.js.map
